import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "angle-brackets",
  "use": "angle-brackets-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"angle-brackets\"><defs><style>#angle-brackets .a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}</style></defs><path class=\"a\" d=\"M9 3.5l-7.793 7.791a1 1 0 000 1.414L9 20.5M15 3.5l7.793 7.793a1 1 0 010 1.414L15 20.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/angle-brackets.svg
// module id = svD2h
// module chunks = 39 44